import React from 'react';
import { isMobile } from 'react-device-detect';
import { mergeClasses } from '@fluentui/react-components';
import WidgetContainer from 'src/components/molecules/widget-container/WidgetContainer';
import { useStore } from 'src/hooks/useStore';
import EnhancedExternalLink from '../../atoms/enhanced-external-link/EnhancedExternalLink';
import { useDailyHabitEmptyPlansStyles } from './DailyHabitsEmptyPlans.styles';

const DailyHabitsEmptyPlans: React.FC = () => {
  const classes = useDailyHabitEmptyPlansStyles();
  const { homeWidgetTextStore } = useStore();
  const startPlanText = homeWidgetTextStore.getHomeWidgetText('DailyHabitsWidget:Button:StartPlan') || 'Start Plan';
  const containerClass = isMobile
    ? mergeClasses('containerMobile', classes.containerMobile)
    : mergeClasses('containerDesktop', classes.containerDesktop);

  return (
    <WidgetContainer title="Daily Habits" footer={<EnhancedExternalLink as="a">{startPlanText}</EnhancedExternalLink>}>
      <div
        className={mergeClasses('container', classes.container, containerClass)}
        data-testid="daily-habits-empty-plans-container"
      >
        <div className={classes.messageContainer}>
          <div className={mergeClasses('textWrapper', classes.textWrapper)}>
            <p className={mergeClasses('title', classes.title)}>
              Take control of your well-being today!
            </p>

            <p className={mergeClasses('description', classes.description)}>
              Start a Plan to start building Daily Habits!
            </p>
          </div>
        </div>

        <div>
          <img
            src="/images/daily-habits-empty-state.png"
            alt="Daily habits empty state"
            className={mergeClasses('image', classes.image)}
          />
        </div>
      </div>
    </WidgetContainer>
  );
};

export default DailyHabitsEmptyPlans;
